function BlankPage() {
  return <></>
}

export default BlankPage
